import { ACCOUNT_TYPES_MAP, FEATURE_FLAGS_NAMES } from '@linearb/linjs-common';
import AppRouter from 'common/AppRouter';
import useTabsBuilder from 'components/RouterTabs/useTabsBuilder';
import SingleSignOn from './SingleSignOn';
import ScimProvisioning from './ScimProvisioning';

const useAuthenticationSettingTabs = () => {
  const tabsBuilder = useTabsBuilder();
  tabsBuilder.initTabs(
    [
      {
        name: 'Single Sign-On',
        path: AppRouter.SINGLE_SIGN_ON.path,
        search: 'isOrgSettings=true',
        permissions: {
          featureFlagName: FEATURE_FLAGS_NAMES.ssoEnabled,
          accountTypes: [ACCOUNT_TYPES_MAP.Primary, ACCOUNT_TYPES_MAP.SuperUser]
        },
        component: <SingleSignOn />
      },
      {
        name: 'SCIM Provisioning',
        path: AppRouter.AUTHENTICATION_SETTINGS_SCIM_PROVISIONING.path,
        search: 'isOrgSettings=true',
        permissions: {
          featureFlagName: FEATURE_FLAGS_NAMES.isScimEnabled,
          accountTypes: [ACCOUNT_TYPES_MAP.Primary, ACCOUNT_TYPES_MAP.SuperUser]
        },
        component: <ScimProvisioning />
      }
    ].filter(Boolean)
  );
  return tabsBuilder.build();
};

export default useAuthenticationSettingTabs;
